import React from 'react';
import Educator from './educator';
import userAPI from '../api/educatorAPI';
import {actions, Loader} from 'react-fields'
import CountriesAPI from "../../components/api/countriesApi";
import BaseFunc from "../base/baseFunctions";
import HoverButton from "../buttons/HoverButton";
import {customPriceRounding, priceFormatting, scrollToError} from "../../components/utils";
import {FadeInSection} from "../../components/fadeIn";

// import InvisibleRecaptcha from '../../components/contact/invisibleRecaptcha';
import PaymentTabs from "../../components/payment/paymentTabs";
import PaymentForm from "../../components/payment/paymentForm";
import RecaptchaScriptLoader from "../../components/base/invisibleRecaptchaScriptLoader";

class Index extends PaymentForm {

    constructor(props){
        super(props);
        const licensesNumber = this.props.offer ? this.props.offer.licenses_number : (this.props.licensesNumber || 5);
        let user = {errors: {}, country_id: this.props.price.country_id, licenses_number: licensesNumber};
        if (this.props.user) {
           ['id', 'name', 'email', 'company_name', 'address', 'city', 'country_id', 'phone', 'postal_code', 'vat_number', 'vat_valid'].map(k => {
               user[k] = this.props.user[k];
           })
        }
        let [totalPrice, totalPriceWithoutDiscount] = this.calculatePrice(licensesNumber);
        if (this.props.offer) {
            totalPrice = this.props.offer.free ? 0 : this.props.offer[`amount_${this.props.price.currency.code.toLowerCase()}`];
        }
        let license_number_options = this.props.discounts.map(d => d.from_number).sort(function(a, b) { return a - b; });
        this.state = {
            user: {...user, needValidateVat: false},
            card: { errors: {}, agree: (this.props.user && !!this.props.user.id)},
            coupon: {errors: {}, code: ""},
            paypal: {...this.props.paypal, ...{errors: {}, agree: (this.props.user && !!this.props.user.id)}},
            isLoading: false,
            paymentMethod: totalPrice > 1000 ? 'bankwire' : 'card',
            discountAmount: 0,
            totalPrice: totalPrice,
            totalPriceWithoutDiscount: totalPriceWithoutDiscount,
            countries: [],
            license_number_options: license_number_options,
            options: {},
            needValidateVat: false
        };
        this.invisibleCaptcha = React.createRef();
    }

    calculatePrice = (licenses_number) => {
        if (licenses_number === 0) { return [0, 0]; }
        let fullPrice = this.props.price.price * parseInt(licenses_number);
        let price = fullPrice;
        const discount = this.props.discounts.find(d => d.from_number === parseInt(licenses_number));
        if (discount) { price = discount[`price_${this.props.price.currency.code.toLowerCase()}`] }
        // price = customPriceRounding(price);
        fullPrice = Math.round(fullPrice * 100) / 100;
        return [price, fullPrice];
    };

    componentDidMount() {
        CountriesAPI.getCollection({}).then((response) => {
            const currentCountry = response.find((c) => c.id === this.state.user.country_id);
            this.setState({countries: response, user: {...this.state.user, needValidateVat: (currentCountry && currentCountry.eu_vat)}})
        }).catch(error => {
            console.log(error);
        });
        window.addEventListener("scroll", this.handleScroll);
    }

    handleScroll = (e) => {
        const shrinkStickyBar = document.querySelector('.license-checkout__widget');
        if (window.pageYOffset > 10) {
            shrinkStickyBar.style.paddingTop = "10px";
            shrinkStickyBar.style.paddingBottom = "10px";
        } else {
            shrinkStickyBar.style.paddingTop = "20px";
            shrinkStickyBar.style.paddingBottom = "20px";
            shrinkStickyBar.style.background="#213341";
        }
    };

    handleFieldChange = (e) => {
        let user = this.state.user;
        let field_name = e.target.name;
        user[field_name] = field_name === 'agree_terms' ? e.target.checked : e.target.value;
        user.errors[actions.camelize(field_name)] = "";
        this.setUser(user);
    };

    // setUser = (user) => {
    //     let updatedState = {user: user};
    //     if (user.country_id !== this.state.user.country_id) {
    //
    //     }
    //     this.setState({user: user});
    // };

    setLicenses = (licenses_number) => {
        let [totalPrice, totalPriceWithoutDiscount] = this.calculatePrice(licenses_number);
        let newState = {totalPrice: totalPrice, totalPriceWithoutDiscount: totalPriceWithoutDiscount, user: {...this.state.user, licenses_number: licenses_number}};
        if (totalPrice >= 10000 ) { newState['paymentMethod'] = 'bankwire'; }
        if (this.state.paymentMethod === 'bankwire' && totalPrice < 1000) { newState['paymentMethod'] = 'card'; }
        this.setState(newState);
    };

    increaseLicenses = () => {
        const current = parseInt(this.state.user.licenses_number);
        if (current === 1000) { return; }
        let currentIndex = this.state.license_number_options.indexOf(current);
        this.setLicenses(this.state.license_number_options[currentIndex+1]);
    };

    decreaeseLicenses = (e) => {
        e.preventDefault();
        const current = parseInt(this.state.user.licenses_number);
        if (current === 5) { return; }
        let currentIndex = this.state.license_number_options.indexOf(current);
        this.setLicenses(this.state.license_number_options[currentIndex-1]);
    };

    createWithOffer = () => {
        this.setState({isLoading: true}, () => {
            userAPI.offer(this.state.user, this.props.offer.id, (response) => {
                window.location.href = response.redirect_to;
            }, (errors) => {
                this.setState({user: {...this.state.user, errors: errors}, isLoading: false}, () => { BaseFunc.scrollToError(); });
            });
        })
    };

    renderPaymentTabs = () => {
      if (this.props.offer && this.props.offer.free) {
          return null;
      }
      let vatType = 'vat_zero';
      if (this.state.user.needValidateVat) {
          vatType = this.state.user.vat_valid ? 'vat_reversed' : 'vat_added';
      }
      let taxAmount = 0;
      let totalPrice = this.state.totalPrice;
      if (vatType === 'vat_added') {
          taxAmount = ((this.state.totalPrice/100) * 19);
          totalPrice = totalPrice + taxAmount;
      }
      const price = {...this.props.price, price: totalPrice, original_price: totalPrice, taxAmount: taxAmount};
      return (
          <div className={`${this.props.user && !!this.props.user.id ? "license-checkout__box" : ""}`}>
              <div className="grid-x license-checkout__tab-area upgrade-form form-container" style={{paddingTop: `${this.props.user && !!this.props.user.id ? '20px' : ''}`}}>
                  <PaymentTabs
                      paymentMethod={this.state.paymentMethod}
                      changePaymentMethod={this.changePaymentMethod}
                      totalPrice={this.state.totalPrice}
                      cardProps={{
                          onChange: this.onCardChange,
                          pay: this.submitOrder,
                          price: price,
                          card: this.state.card,
                          afterPaymentUrl: this.props.afterPaymentUrl,
                          discountAmount: this.state.discountAmount,
                          user: this.state.user,
                          hideCouponArea: true,
                          validate: this.validate,
                          countryCode: this.props.countryCode,
                          vatType: vatType,
                          purchaseType: this.props.purchaseType
                      }}
                      paypalProps={{
                          pay: this.submitOrder,
                          price: price,
                          discountAmount: this.state.discountAmount,
                          paypal: this.state.paypal,
                          description: this.props.description,
                          validate: this.validate,
                          afterPaymentUrl: this.props.afterPaymentUrl,
                          onChange: this.onPayPalChange,
                          totalPrice: totalPrice,
                          purchaseType: this.props.purchaseType,
                          user: this.state.user,
                          hideCouponArea:true,
                          vatType: vatType}}
                      bankWireProps={{
                          user: this.state.user,
                          price: price,
                          discountAmount: this.state.discountAmount,
                          onChange: this.setUser,
                          afterPaymentUrl: this.props.afterPaymentUrl,
                          pay: this.submitOrder,
                          vatType: vatType
                      }}
                  />
              </div>
          </div>
      )
    };

    render() {
        const curSymbol = this.props.price.currency.symbol;
        return (
            <FadeInSection>
                <React.Fragment>
                    {this.state.isLoading ? <Loader/> : null}
                    <div className={`license-checkout__box ${this.props.user && !!this.props.user.id ? "license-checkout__box--sticky" : ""}`}>
                        <div className={`grid-x license-checkout__widget ${this.props.user && !!this.props.user.id ? "" : "license-checkout__widget--sticky"} `}>
                            <div className="small-6 cell license-checkout__control license-checkout__control--vertical ">
                                <div className="flex-center license-checkout__control--aligned">
                                    <h3 className="license-checkout__widget__counter">{this.state.user.licenses_number}<span
                                        className="hide-for-small-only">&nbsp;user licenses</span></h3>
                                    { this.props.offer ? null :
                                    <div className="license-checkout__buttons">
                                        <HoverButton onClick={this.decreaeseLicenses} className={'group__button group__button--negative custom-button'}>
                                            <span className="small-icon minus-icon--black"/>
                                        </HoverButton>
                                        <HoverButton onClick={this.increaseLicenses} className={'group__button group__button--positive custom-button'}>
                                            <span className="small-icon plus-icon--white"/>
                                        </HoverButton>
                                    </div> }
                                </div>
                                <h3 className="show-for-small-only license-checkout__widget__counter small-space">User Licenses</h3>
                            </div>
                            <div className="small-6 cell flex-end">
                                <div className="group__total group__total--container">
                                    <div className="group__sup line-through small-order-1 medium-order-3">
                                            <span className="group__small group__small--white">{priceFormatting(this.state.totalPriceWithoutDiscount, curSymbol)}</span>
                                    </div>
                                    <div className="group__total medium-order-2">
                                        <div className="group__price group__price--white small-order-2 medium-order-2">Total {priceFormatting(this.state.totalPrice, curSymbol)}</div>

                                    </div>
                                </div>

                            </div>
                        </div>
                        {this.props.offer && !this.props.offer.full_access ?
                            <div className="license-checkout__group-access">
                                <p className="license-checkout__group-access--title">Individual Test Access to CareerHunter</p>
                                <p className="license-checkout__group-access--desc">Individual test access allows you to invite your team and students to take certain tests at CareerHunter. Includes two test takes per license.</p>
                            </div>
                            : <div className="license-checkout__group-access">
                            <p className="license-checkout__group-access--title">Group Access to CareerHunter</p>
                            <p className="license-checkout__group-access--desc">Group access allows you to invite your team and students to enjoy the full career matching and testing experience at CareerHunter. Includes two test takes per license.</p>
                        </div> }

                        {this.props.user && !!this.props.user.id ? null :
                            <Educator setUser={this.setUser} user={{...this.state.user}} countries={this.state.countries}
                                      onSubmit={this.props.offer && this.props.offer.free ? this.createWithOffer : null} />
                        }
                        {this.props.user && !!this.props.user.id ? null : this.renderPaymentTabs()}
                    </div>
                    {this.props.user && !!this.props.user.id ? this.renderPaymentTabs() :null}

                    {/*<InvisibleRecaptcha ref={this.invisibleCaptcha}*/}
                                        {/*sitekey={this.props.recaptchaKey}*/}
                                        {/*verifyCallback={this.sendOrder} />*/}
                    <RecaptchaScriptLoader sitekey={this.props.recaptchaKey} />
                </React.Fragment>
            </FadeInSection>
            )

    }



}
export default Index;